import { useState } from "react";
import { ClipboardPaste } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const SERVICES = [["knee-pain", "Knee pain"], ["back-pain", "Back & spine"], ["sports-injury", "Sports injury"], ["post-surgery", "Post-surgery"], ["sports-massage", "Sports massage"]];

export const PasteReviews = ({ onSaved }) => {
  const [f, setF] = useState({ quote: "", author: "", service: SERVICES[0][0] });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/profile/reviews/paste", f);
      onSaved(data.testimonials);
      setF({ ...f, quote: "", author: "" });
      toast.success("Google review saved. Matching landing pages use it right away.");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="paste-reviews" className="mb-6 rounded-md border border-emerald-500/20 bg-emerald-500/5 p-4">
      <div className="cc-eyebrow mb-1 flex items-center gap-2 text-emerald-300"><ClipboardPaste className="h-3.5 w-3.5" /> Paste reviews from Google</div>
      <p className="mb-3 text-xs text-slate-400">Copy a review from your Google Business Profile exactly as written. It is saved as a real testimonial with source “Google review”, then shown on landing pages with the same service tag.</p>
      <textarea data-testid="paste-review-quote" rows={4} className="cc-input resize-y" placeholder="Paste the review text exactly as written" value={f.quote} onChange={set("quote")} />
      <div className="mt-2 flex flex-col gap-2 md:flex-row">
        <input data-testid="paste-review-author" className="cc-input" placeholder="Reviewer name as shown on Google" value={f.author} onChange={set("author")} />
        <select data-testid="paste-review-service" className="cc-input md:w-56" value={f.service} onChange={set("service")}>{SERVICES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <button type="button" data-testid="paste-review-save" onClick={save} disabled={busy || f.quote.trim().length < 20 || f.author.trim().length < 2} className="cc-btn cc-btn-primary whitespace-nowrap">{busy ? "Saving…" : "Save review"}</button>
      </div>
    </div>
  );
};
